module.exports = "/static/assets/e7db9233bdad32581beaf13e0162703a.png";